import Button from 'atoms/Button';
import Modal from 'atoms/Modal';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppDispatch } from 'store';
import { closeModal } from 'store/layoutSlice';
import { deleteProject } from 'store/projectsThunks';

type DeleteProjectModalProps = {
    projectId?: string;
    projectName?: string;
    taskCount?: number;
};

export const DeleteProjectModal = ({
    projectId,
    projectName,
    taskCount,
}: DeleteProjectModalProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);

    const handleClose = () => {
        dispatch(closeModal({ name: 'deleteProject' }));
    };

    const handleConfirm = () => {
        if (!projectId) return;

        setIsDeleting(true);
        dispatch(deleteProject(projectId))
            .then(() => {
                handleClose();
            })
            .catch(() => {
                setIsDeleting(false);
            });
    };

    return (
        <Modal size="s" open={true} onClose={handleClose}>
            <header>
                <h2>{t('PROJECT.DELETE_MODAL_TITLE')}</h2>
            </header>
            <main>
                <p style={{ marginBottom: '24px' }}>
                    {t('PROJECT.DELETE_MODAL_QUESTION', { name: projectName })}
                    {taskCount && taskCount > 0 && (
                        <>{' '}{t('PROJECT.DELETE_MODAL_TASK_COUNT', { count: taskCount })}</>
                    )}{' '}
                    {t('PROJECT.DELETE_MODAL_UNDONE')}
                </p>
            </main>
            <footer>
                <div />
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        justifyContent: 'center',
                    }}
                >
                    <Button size="m" theme="blank" onClick={handleClose}>
                        {t('PROJECT.DELETE_MODAL_CANCEL')}
                    </Button>
                    <Button
                        size="m"
                        theme="primary"
                        onClick={handleConfirm}
                        loading={isDeleting}
                    >
                        {t('PROJECT.DELETE_MODAL_CONFIRM')}
                    </Button>
                </div>
            </footer>
        </Modal>
    );
};